jQuery(document).ready(function($) {
    // On page load, check the initial value of each select element
    $('select.gfield_select').each(function() {
        var selectedValue = $(this).find('option:selected').val();
        if (selectedValue === '') { // Check if it's the placeholder option
            $(this).css('color', '#949494'); // Set placeholder color
        } else {
            $(this).css('color', '#000'); // Set default color
        }
    });

    // Listen for change events on select elements with the gfield_select class
    $('select.gfield_select').on('change', function() {
        var selectedValue = $(this).find('option:selected').val();
        if (selectedValue === '') { // Check if the placeholder option is selected
            $(this).css('color', '#949494'); // Set placeholder color
        } else {
            $(this).css('color', '#000'); // Set default color
        }
    });
});
